import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { Controller } from 'react-hook-form';

const ControlledCheckboxInput = props => {
  const {
    name,
    control,
    icon = <CheckBoxOutlineBlankIcon fontSize="small" />,
    checkedIcon = <CheckBoxIcon fontSize="small" />,
    ...rest
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => {
        return (
          <Checkbox
            type="checkbox"
            icon={icon}
            checkedIcon={checkedIcon}
            checked={value}
            onChange={e => onChange(e.target.checked)}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ControlledCheckboxInput;
